import React from "react";

export default function SupportFaqBox(props) {
  return (
    <div className="accordion-item singleFaq">
      <h2 className="accordion-header">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#${props.faqId}`}
          aria-expanded="true"
          aria-controls="collapseOne"
        >
          {props.question}
        </button>
      </h2>
      <div
        id={props.faqId}
        className="accordion-collapse collapse"
        data-bs-parent="#faqAccordion"
      >
        <div className="accordion-body">{props.answer}</div>
      </div>
    </div>
  );
}
